import { Airror, IDP_ACCOUNT_EXISTS } from '@air/errors';

export const isIncorrectUsernameOrPasswordError = (error: Error | Airror) =>
  error.message.includes('NotAuthorizedException');

export const isUserDoesNotExistError = (error: Error | Airror) => error.message.includes('UserNotFoundException');

export const isUserDoesNotHavePasswordError = (error: Error | Airror) =>
  error.message.includes(IDP_ACCOUNT_EXISTS.message);
